"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalManagerPermissions = void 0;
var enum_1 = require("../enum");
exports.internalManagerPermissions = [
    enum_1.Permissions.CanCreateAnyUserType,
    enum_1.Permissions.CanIgnoreCustomGrants,
    enum_1.Permissions.CanManageAllAccounts,
];
